<template>
  <label
    :class="[
      'switch-wrapper',
      { 'disabled-element': disabled, 'deactived-element': deactived },
    ]"
  >
    <input
      :disabled="disabled || deactived"
      ref="input"
      type="checkbox"
      :checked="checked && !disabled"
      @change="toggle"
    />
    <span />
    <slot />
  </label>
</template>
<script>
export default {
  name: 'Switcher',
  props: {
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    deactived: {
      type: Boolean,
    },
  },
  methods: {
    toggle() {
      if (this.disabled || this.deactived) return;
      this.$refs.input.checked = this.checked;
      this.$emit('change', !this.checked);
    },
  },
};
</script>
<style scoped>
.switch-wrapper {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 2.4em;
  height: 1.2em;
}

.switch-wrapper input {
  display: none;
}

/* The slider */
.switch-wrapper span {
  position: absolute;
  cursor: pointer;
  top: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  border-radius: 1em;
  background-color: #898989;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch-wrapper span:before {
  position: absolute;
  border-radius: 50%;
  content: '';
  height: 1em;
  width: 1em;
  left: 0.1em;
  bottom: 0.1em;
  background-color: #fff;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.switch-wrapper input:checked + span {
  background-color: #ed7e57;
}

.switch-wrapper input:checked + span:before {
  transform: translateX(1.2em);
}

.deactived-element {
  visibility: hidden;
}

.disabled-element.switch-wrapper input + span {
  background-color: #ddd;
  cursor: default;
}

.disabled-element span:before {
  background-color: #f2f2f2;
  cursor: default;
}
</style>
